<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.25 5.75C9.97388 5.75 9.75002 5.97386 9.75002 6.25C9.75002 6.52614 9.97388 6.75 10.25 6.75H13.6753L6.36757 15.4279C6.18969 15.6392 6.21673 15.9546 6.42795 16.1325C6.63918 16.3103 6.9546 16.2833 7.13248 16.0721L15.1325 6.57207C15.2577 6.42331 15.2854 6.21542 15.2034 6.03909C15.1213 5.86276 14.9445 5.75 14.75 5.75H10.25ZM14.25 18.25C14.5261 18.25 14.75 18.0261 14.75 17.75C14.75 17.4739 14.5261 17.25 14.25 17.25H10.8247L18.1325 8.57207C18.3103 8.36084 18.2833 8.04542 18.0721 7.86754C17.8608 7.68967 17.5454 7.71671 17.3675 7.92793L9.36754 17.4279C9.24228 17.5767 9.21463 17.7846 9.29666 17.9609C9.37869 18.1372 9.55552 18.25 9.75 18.25H14.25Z"
      :fill="clr"
    />
  </svg>
</template>

<script>
export default {
  props: {
    clr: {
      default: "#768391"
    }
  }
};
</script>
